import React from 'react';

import { Currency } from '@/constants';
import useBuildInfoStore from '@/hooks/useBuildInfo';

import BuildDetailsGrid, { BuildDetailsGridLabelValuePair } from '../components/BuildDetailsGrid';

const BuildDetailsTokenInfoBeta: React.FC<{ currency: Currency; betaData: unknown }> = ({ currency, betaData }) => {
  const { buildInfo } = useBuildInfoStore();

  const contractDetailsByCurrency = buildInfo?.[currency];

  if (!contractDetailsByCurrency) return null;

  return (
    <BuildDetailsGrid
      collapsible
      content={
        <ul>
          <li>
            <BuildDetailsGrid>
              <BuildDetailsGridLabelValuePair
                label={'Parameters'}
                value={
                  <div className="bg-background/50 max-w-full overflow-x-auto rounded-xl px-4 py-2 text-[8px]">
                    <pre>{JSON.stringify(betaData, null, 2)}</pre>
                  </div>
                }
              />
            </BuildDetailsGrid>
          </li>
        </ul>
      }
    >
      <div>Beta</div>
    </BuildDetailsGrid>
  );
};

export default BuildDetailsTokenInfoBeta;
